import type { QuoteCreatePayload, WarehouseFields } from './fixtures';

/** Adapt the create request to the revision tabs without seeding sample data.
 * Keep the request as the source of truth so untouched optional numbers stay unset. */
export function warehouseCreateDraft(t: NonNullable<QuoteCreatePayload['transload']>): WarehouseFields {
  const str = (value: string | number | undefined) => value == null ? '' : String(value);
  const yn = (value: string | undefined) => value === 'Y' ? 'Y' : 'N';
  return {
    moveType: t.movetype, size: t.size, accountType: t.accounttype ?? '',
    whseType: t.whsetype ?? '', rateZone: t.ratezone ?? '', commodity: t.commodity ?? '',
    packageType: t.packagetype ?? '', numUnits: t.numunits ?? '',
    packagePerContainer: t.packagepercontainer ?? null, hazmat: yn(t.hazmat),
    equipType: t.equiptype ?? '', lbs: str(t.lbs), kgs: str(t.kgs),
    legalWeight: yn(t.legalweight), overweight: yn(t.overweight), oog: yn(t.oog),
    triaxle: yn(t.triaxle), swing: yn(t.swing), chassisType: t.chassistype ?? '',
    numOverflow: t.numoverflow ?? null, perContainers: t.percontainers ?? null,
    warehouse: t.warehouse ?? '', drayRate: str(t.drayrate), drayWithCharges: '0',
    drayType: t.draytype ?? '', fuelSurcharge: str(t.fuelsurcharge),
    fuelType: t.fueltype ?? '', fuelTariff: t.fueltariff ?? null,
    drayHandlingCharge: str(t.drayhandlingcharge), drayHandlingUnitType: t.drayhandlingunittype ?? '',
    handlingWithCharges: '0', includeHandlingInDray: yn(t.includehandlingindray ?? 'Y'),
    storageType: t.storagetype ?? '', storageAnniversaryDays: t.storageanniversarydays ?? null,
    storageRate: str(t.storagerate), storageRateLongTerm: str(t.storageratelongterm),
    storageUnitType: t.storageunittype ?? '', storageRcvMonthFree: yn(t.storagercvmonthfree),
    storageFreeDays: t.storagefreedays ?? null, storageFreePallets: t.storagefreepallets ?? null,
    storageDoNotBillReason: t.storagedonotbillreason ?? '', comments: t.comments ?? '',
    ess: yn(t.hvc), cargoValue: t.cargovalue ?? null,
    lengthInches: str(t.lengthinches), widthInches: str(t.widthinches), heightInches: str(t.heightinches),
    waitingTimeFree: str(t.waitingtimefree), yardStorageFree: t.yardstoragefree ?? null,
    unitsPerContainer: t.unitspercontainer ?? null, useSlidingScale: yn(t.useslidingscale),
    chassisFeeType: t.chassisfeetype ?? '', chassisFeeDays: t.chassisfeedays ?? null,
    lightweightChassisFeeType: t.lightweightchassisfeetype ?? '',
    lightweightChassisFeeDays: t.lightweightchassisfeedays ?? null,
    productRates: [],
  };
}
